import React from 'react';
import QRCode from 'qrcode.react';
import Swiper from 'react-id-swiper';
import { BrowserView, MobileView } from 'react-device-detect';

import Footer from './components/footer';

const monthNames = ["January", "Feburary", "March", "April", "May", "June", "July", "August", "September", "October", "Novemeber", "December"];

class Theme extends React.Component {
  async componentDidMount() {
	if (this.props.match.params) {
		this.themeKey = this.props.match.params.themeId.replace('-', '_')
	}
  }

  render() {
	document.body.classList.remove('inner-page');
	
	const sliderParams = {
		effect: 'coverflow',
		grabCursor: true,
		initialSlide: 2,
		centeredSlides: true,
		loop: true,
		spaceBetween: 0,
		slidesPerView: 4,
		pagination: {},
		coverflowEffect: {
			rotate: 0,
			stretch: 0,
			depth: 100,
			modifier: 1.43,
			slideShadows: false,
		},
		autoplay: {
			delay: 5000,
		},
		breakpoints: {
			360: {
				slidesPerView: 1,
				coverflowEffect: {
					depth: 50,
					modifier: 0,
				},
			},
			640: {
				slidesPerView: 3,
				coverflowEffect: {
					depth: 80,
					modifier: 0,
				},
			}
		}
	}

	var themeKey = "";
	if (this.props.match.params) {
		themeKey = this.props.match.params.themeId.replaceAll('-', '_')
	}
	
	const infoMap = {
		abstract_botany: {
			name: "Abstract Botany",
			imageKey: "abstract_botany",
			link: "https://calist.co/link/xr8u"
		},
		abstract_faces: {
			name: "Abstract Faces",
			imageKey: "abstract_faces",
			link: "https://calist.co/link/Ws4t"
		},
		abstract_landmarks: {
			name: "Abstract Landmarks",
			imageKey: "abstract_landmarks",
			link: "https://calist.co/link/rK6c"
		},
		beaches: {
			name: "Beaches",
			imageKey: "beach",
			link: "https://calist.co/link/CQLs"
		},
		city_houses: {
			name: "City Houses",
			imageKey: "city_houses",
			link: "https://calist.co/link/5mEq"
		},
		constellations: {
			name: "Constellations",
			imageKey: "constellations",
			link: "https://calist.co/link/ox1L"
		},
		cute_puzzle_animals: {
			name: "Cute Puzzle Animals",
			imageKey: "cute_animals",
			link: "https://calist.co/link/egZf"
		},
		geometric_arts: {
			name: "Geometric Arts",
			imageKey: "geometric_arts",
			link: "https://calist.co/link/3LNQ"
		},
		geometric_shapes: {
			name: "Geometric Shapes",
			imageKey: "geometric_shapes",
			link: "https://calist.co/link/UAJh"
		},
		house_plants: {
			name: "House Plants",
			imageKey: "house_plants",
			link: "https://calist.co/link/H3Xd"
		},
		landscapes: {
			name: "Landscapes",
			imageKey: "landscapes",
			link: "https://calist.co/link/JTT6"
		},
		playful_abstractions: {
			name: "Playful Abstractions",
			imageKey: "playful_abstractions",
			link: "https://calist.co/link/4vDS"
		},
		puzzle: {
			name: "Puzzle",
			imageKey: "puzzle",
			link: "https://calist.co/link/QYkB"
		},
		shapes: {
			name: "Shapes",
			imageKey: "shapes",
			link: "https://calist.co/link/y7qJ"
		},
		sun: {
			name: "Sun",
			imageKey: "sun",
			link: "https://calist.co/link/bjYi"
		},
		zodiac_signs: {
			name: "Zodiac Signs",
			imageKey: "zodiac_signs",
			link: "https://calist.co/link/1Crm"
		},
	}

	let montScreenShots = [];
	if (infoMap[themeKey] !== undefined) {
		for (let i = 2; i <= 12; i++) {
			montScreenShots.push(
				<div className="swiper-slide">
					<img src={"assets/images/themes/" + infoMap[themeKey].imageKey + "/calist_2022_calendar_" + infoMap[themeKey].imageKey + "_" + i + ".png"} alt={"Calist 2022 Calendar - " + monthNames[i - 1] +  infoMap[themeKey].name }/>
				</div>
			);
		}
	}
  	return (
  		<div>
  			{/* Navbar Section*/}
  			<nav className="navbar navbar-expand-lg  theme-nav fixed-top">
				<div className="container">
					<a className="navbar-brand main-title" href={`${process.env.PUBLIC_URL}/`}>
						<img src="assets/images/calist-logo-small.png" alt="Calist logo"/>
					</a>
					<div className="collapse navbar-collapse" id="mainmenu">
						<ul className="navbar-nav ml-auto" id="mymenu">

							<li className="nav-item">
								<a className="nav-link" href="#screenshots" > </a>
							</li>
						</ul>
					</div>
				</div>
			</nav>

  			{/* Home One Section Start */}
			<section className="slide-bg" id="home">
				<div className="animation-circle">
					<i></i>
					<i></i>
					<i></i>
				</div>
				<div className="container">
					<div className="row">
						<div className="col-md-6">
							<div className="d-flex-1">
								<div className="slide-text" style={{width: "100%"}}>
									<div>
										{
											infoMap[themeKey] !== undefined &&
											<h1>{infoMap[themeKey].name}</h1>
										}
										
										{
											infoMap[themeKey] !== undefined &&
											<div className="row" style={{paddingTop: 10}}>
												<div className="col-md-6">
													<BrowserView>
														<a href="https://apps.apple.com/app/id1590186123">
															<img width={220} src="assets/images/apple_download.svg" alt="Download Clist at App Store" className="img-fluid"/>
														</a>
													</BrowserView>
													<MobileView>
													<a href={infoMap[themeKey].link}>
															<img width={220} src="assets/images/apple_download.svg" alt="Download Clist at App Store" className="img-fluid"/>
														</a>
													</MobileView>
												</div>
												<div className="col-md-3 d-none d-md-block">
													<QRCode value={infoMap[themeKey].link} size={75}/>
												</div>
											</div>
										}
										{
											infoMap[themeKey] === undefined &&
											<div>
												<h1>iPhone Calendar Themes</h1>
												<div className="row" style={{paddingTop: 10}}>
													<div className="col-md-7">
														<BrowserView>
															<a href="https://apps.apple.com/app/id1590186123">
																<img width={220} src="assets/images/apple_download.svg" alt="Download Clist at App Store" className="img-fluid"/>
															</a>
														</BrowserView>
														<MobileView>
															<a href="https://calist.co/link/Sohr">
																<img width={220} src="assets/images/apple_download.svg" alt="Download Clist at App Store" className="img-fluid"/>
															</a>
														</MobileView>
													</div>
													<div className="col-md-3 d-none d-md-block">
														<QRCode value="https://calist.co/link/Sohr" size={75}/>
													</div>
												</div>
											</div>
										}
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="home-right">
								<div className="mobile-slid">
									{
										infoMap[themeKey] !== undefined &&
										<img src={"assets/images/themes/" + infoMap[themeKey].imageKey + "/calist_2022_calendar_" + infoMap[themeKey].imageKey + "_1.png"} alt={"Calist 2022 Calendar - " + monthNames[0] +  infoMap[themeKey].name } className="img-fluid"/>
									}
									{
										infoMap[themeKey] === undefined &&
										<img src="assets/images/themes/abstract_landmarks/calist_2022_calendar_abstract_landmarks_1.png" alt="top1" className="img-fluid"/>
									}
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
  			{/* Home One Section End */}

			{
				infoMap[themeKey] !== undefined &&
				<section id="screenshots" className="theme-bg screenshots" >
					<div className="container">
						<div className="row">
							<div className="col-md-12 text-center">
								<div className="section-title">
									<h2 className="text-mine-shaft">2022 Calendar Themes</h2>
									<img src="assets/images/white-line.png" alt="title-line" className="img-fluid" />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-sm-12">
								<Swiper {...sliderParams} className="swiper-screenshots-container-1 swiper-container">
									{montScreenShots}
								</Swiper>
							</div>
						</div>
					</div>
				</section>
			}

			{/*Footer Component*/}
			<Footer />

			{/*tap-top*/}
			<div className="tap-top">
				<div>
					<i className="fa fa-angle-up" aria-hidden="true"></i>
				</div>
			</div>
  		</div>
  	);
  }
}

export default Theme;


// WEBPACK FOOTER //
// ./src/theme.js